import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';

const rootElement = document.getElementById('root');

const theme = createTheme()

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  rootElement
);
